import { Applicant } from "./applicant";
import { Area } from "./area";
import { Company } from "./company";
import { Division } from "./division";
import { Employee } from "./employee";
import { OfferBenefit } from "./offer-benefit";
import { OfferSignature } from "./offer-signature";
import { OfferStatus } from "./offer-status";
import { OfferWithholding } from "./offer-withholding";
import { Position } from "./position";

export class Offer {
    id: number = 0;
    typeOffer!: string;
    folio!: string;
    workLocation!: string;

    //position!: string;
    position: Position | null | undefined = new Position();

    baseSalary!: number;

    observations!: string;
    justification!: string;

    startDateEmployment!: Date;

    active: boolean = false;

    applicant: Applicant | null | undefined = new Applicant();
    employee: Employee | null | undefined = new Employee();

    //company: Company | null | undefined = new Company;
    division: Division | null | undefined = new Division();
    area: Area | null | undefined = new Area();

    offerBenefitList: OfferBenefit[] = [];
    offerWithholdingList: OfferWithholding[] = [];

    status: OfferStatus | null | undefined = new OfferStatus();
    offerSignatures: OfferSignature[] = [];

    salaryDifference!: number;
    /*guaranteedBenefits!: number;
    periodicBenefits!: number;
    singlePaymentBenefits!: number;
    otherBenefits!: number;*/
}